import {AnimationService} from "../service/animation";
import OpenAccordion from "../animations/open-accordion";
import CloseAccordion from "../animations/close-accordion";

interface PostArticle {
    articleImage: string,
    baseArticleNumber: string,
    featureText: string,
    itemId: string,
    longText: string,
    manufacturerId: string,
    seriesId: string,
    shortText: string,
    variantCode: string,
}

interface PostData {
    articles: PostArticle[],
    obxUrl: string,
    pdfUrl: string,
    reopenUrl: string,
}

export class ProductConfiguratorComponent
{
    private $root:JQuery;
    private $window:JQuery;
    private popupId: number;

    constructor(element:HTMLElement) {
        this.$root = $(element);
        this.popupId = parseInt(this.$root.data('popup_id'));
        this.$window = $(<any>window);
    }

    protected onShow(popupId:number, data:PostData) {
        let $form = $('.elementor-'+this.popupId);
        if (0 !== $form.length) {
            $form.find('[name="form_fields[pcondata]"]').val(JSON.stringify(data));
            let article = data.articles.shift();
            Object.keys(article).forEach((key: string) => {
                let $field = $form.find('[name="form_fields['+key+']"]');
                if (0 !== $field.length) {
                    // @ts-ignore
                    $field.val(article[key]);
                }
            });
        }
    }

    protected handleMessage = (messageEvent: any) => {
        let data = <any>messageEvent.originalEvent.data;
        if (undefined !== data && undefined !== data.action && data.action === 'contact-request') {
            $(document).on('elementor/popup/show', (popupEvent: any, popupId: number) => this.onShow(popupId, data.data));
            (<any>this.$window.get(0)).elementorProFrontend.modules.popup.showPopup({id: this.popupId});
        }
    }

    protected init() {
        console.log('initialising product configurator');
        this.$window.on('message', this.handleMessage);
    }
}